export const environment = {
  production: false,
  supabaseUrl: 'https://ewltnrfqwkhimnyqfrrw.supabase.co',
  supabaseAnonKey: 'sb_publishable_U5Z6XXT05q7Wx0NPUijkBg_R7OZbTQL'
};